import { useState } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysOrderPurchaseDetailPur2GoodsRegisterDialog from "../dialogTypes/MomSysOrderPurchaseDetailPur2GoodsRegisterDialog";

function MomSysOrderPurchaseDetailPur2GoodsRegisterButton(props) {
    const {
        id,
        schema,
        onSuccess,
        createButtonName,
        customizeErrorMsgCallback,
        onDialogUpdateDetail,
        orderPurchaseMstSelect,
        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-pur2-goods-register-button"}
                onClick={onOpen}
                createButtonName={"orderPurchaseDetailPur2GoodsRegister"}
                {...others}
            />
            <MomSysOrderPurchaseDetailPur2GoodsRegisterDialog
                id={id + "-pur2-goods-register-dialog"}
                mode="create"
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                onDialogUpdateDetail={onDialogUpdateDetail}
                orderPurchaseMstSelect={orderPurchaseMstSelect}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default MomSysOrderPurchaseDetailPur2GoodsRegisterButton;
